import AHttpService from '@d-services/a-http-service/a-http-service';
import { addObjectToFormData } from '@d-shared/forms/forms';
import URLS from '@d-shared/urls/urls';

class ProfileService extends AHttpService {
  async getProfile() {
    const response = await this._http.get(URLS.api.user);
    return response.data;
  }

  async getSlug() {
    const response = await this._http.get(URLS.api.userSlug);
    return response.data;
  }

  async saveDirectSubmissionsGuidelines(directSubmissionsGuidelines) {
    const data = {
      profile: {
        direct_submissions_guidelines: directSubmissionsGuidelines,
      },
    };

    const formData = new FormData();
    addObjectToFormData(data, formData);

    const response = await this._http.put(URLS.api.user, formData);
    return response.data;
  }

  async saveHideGoodreadsImportModal(hideGoodreadsImportModal) {
    const data = {
      profile: {
        hide_goodreads_import_modal: hideGoodreadsImportModal,
      },
    };

    const formData = new FormData();
    addObjectToFormData(data, formData);

    const response = await this._http.patch(URLS.api.user, formData);
    return response.data;
  }

  async saveDirectSubmissionsState(isAcceptingDirectSubmissions) {
    const data = {
      profile: {
        accepting_direct_submissions: isAcceptingDirectSubmissions,
      },
    };

    const formData = new FormData();
    addObjectToFormData(data, formData);

    const response = await this._http.put(URLS.api.user, formData);
    return response.data;
  }

  async saveProfile(data) {
    const formData = new FormData();
    addObjectToFormData(data, formData);

    const response = await this._http.put(URLS.api.user, formData);
    return response.data;
  }
}

export default new ProfileService();
